module.exports = __webpack_public_path__ + "static/img/icon_zanwujtffjl.28f3bdee.png";